import script from "./NavegacionTabla.vue?vue&type=script&setup=true&lang=js"
export * from "./NavegacionTabla.vue?vue&type=script&setup=true&lang=js"

import "./NavegacionTabla.vue?vue&type=style&index=0&id=30d6ba0e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30d6ba0e"]])

export default __exports__